@if(openOnClick()){
<label
    [id]="id()"
    #trigger="cdkOverlayOrigin"
    class="iq-md"
    (click)="toggle()"
    cdkOverlayOrigin
    [attr.data-testid]="id()"
    [attr.data-styletarget]="id()"
    [attr.data-uitype]="'label'"
    [datiqTemplateMd]="label()"
></label>
<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen()"
    (backdropClick)="close()"
>
    @if(showHeader()) {
    <section class="bg-dat-blue-700 animate-tooltip rounded-sm p-2 text-white">
        <header
            class="font-caption-strong iq-md"
            [datiqTemplateMd]="tooltipHeader()"
        ></header>

        <section
            class="grid grid-cols-[24px_minmax(50px,_1fr)] gap-2 items-center"
        >
            <span class="col-span-1"
                ><mat-icon class="material-symbols-outlined"
                    >info</mat-icon
                ></span
            >
            <span
                class="col-span-1 font-caption iq-md"
                [datiqTemplateMd]="tooltipBody()"
            ></span>
        </section>
    </section>

    } @else{

    <section
        [attr.data-uitype]="'tooltip'"
        class="bg-dat-blue-700 rounded-sm p-2 animate-tooltip text-white font-caption-strong iq-md"
        [datiqTemplateMd]="tooltipBody()"
    ></section>
    }
</ng-template>
} @else {
<label
    [id]="id()"
    #trigger="cdkOverlayOrigin"
    class="iq-md"
    (mouseenter)="handleMouseEnter()"
    (mouseleave)="handleMouseLeave()"
    cdkOverlayOrigin
    [attr.data-testid]="id()"
    [attr.data-styletarget]="id()"
    [attr.data-uitype]="'label'"
    [datiqTemplateMd]="label()"
></label>
<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen()"
    (backdropClick)="isOpen.set(false)"
>
    @if(showHeader()) {
    <section 
        class="bg-dat-blue-700 animate-tooltip rounded-sm p-2 text-white"
        (mouseenter)="handleTooltipMouseEnter()"
        (mouseleave)="handleTooltipMouseLeave()"
    >
        <header
            class="font-caption-strong iq-md"
            [datiqTemplateMd]="tooltipHeader()"
        ></header>

        <section
            class="grid grid-cols-[24px_minmax(50px,_1fr)] gap-2 items-center"
        >
            <span class="col-span-1"
                ><mat-icon class="material-symbols-outlined"
                    >info</mat-icon
                ></span
            >
            <span
                class="col-span-1 font-caption iq-md"
                [datiqTemplateMd]="tooltipBody()"
                (click)="handleTooltipClick()"
            ></span>
        </section>
    </section>

    } @else{

    <section
        [attr.data-uitype]="'tooltip'"
        class="bg-dat-blue-700 rounded-sm p-2 animate-tooltip text-white font-caption-strong iq-md"
        (mouseenter)="handleTooltipMouseEnter()"
        (mouseleave)="handleTooltipMouseLeave()"
        [datiqTemplateMd]="tooltipBody()"
        (click)="handleTooltipClick()"
    ></section>
    }
</ng-template>
}